<template>
  <div class="loader__container">
    <svg
      width="171"
      height="253"
      viewBox="0 0 171 263"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M141.109 74.3145C141.268 66.5285 140.508 53.3304 136.709 39.531C132.91 25.7315 125.501 12.5967 124.425 10.9193C123.348 12.6284 117.492 23.2628 112.331 39.9424C110.97 44.9432 108.532 55.7992 108.089 66.3703C107.582 79.1886 109.324 91.9119 110.02 95.5201C110.02 91.2789 110.115 77.1313 112.743 65.4524C115.37 53.7419 120.373 40.2906 124.425 33.4542C128.826 40.6704 134.334 56.2106 136.265 65.5157C138.228 74.8525 139.241 86.753 138.83 95.2036C140.001 90.2978 140.919 82.0688 141.109 74.3145ZM124.488 133.88C126.863 129.481 130.947 119.827 130.567 107.579C130.06 95.077 125.85 85.8984 124.552 83.7146C123.095 85.8984 118.188 96.4063 118.283 108.718C118.663 121.347 122.209 129.576 124.488 133.88ZM142.439 39.6892C147.061 60.0719 146.998 72.6054 144.972 86.9112C141.331 112.643 129.617 132.329 124.552 138.944C121.069 134.45 115.75 125.303 112.204 116.789C112.204 116.789 105.493 100.552 103.72 84.7274C101.947 68.9023 102.707 52.7924 107.867 34.6885C112.648 18.4204 121.955 3.79801 124.488 0C126.103 2.69026 137.785 19.3066 142.439 39.6892ZM152 143.248V195.756C137.975 210.663 118.03 220 95.9 220C53.4451 220.032 19 185.723 19 143.438C19 101.185 53.4451 66.9083 95.9 66.9083V124.48C84.851 124.48 73.802 128.689 65.3806 137.077C63.3544 139.071 61.6132 141.223 60.0936 143.47C48.7912 160.181 50.5325 183.096 65.3806 197.877C73.802 206.232 84.851 210.473 95.9 210.473C106.886 210.473 117.903 206.327 126.324 197.971C126.356 197.908 126.419 197.908 126.451 197.877V197.813L126.578 197.718C135.031 189.331 135.031 175.658 126.578 167.303C118.125 158.884 104.448 158.884 96.0267 167.303C95.9633 167.334 95.9317 167.334 95.9317 167.397V143.28H152V143.248Z"
        fill="white"
      />
      <!-- <loader__circle class="📦" cx="10.5" cy="263.5" r="10.5" fill="white" /> -->
      <!-- <loader__circle cx="10.5" cy="263.5" r="6" fill="white" />
      <loader__circle cx="52" cy="263" r="6" fill="white" />
      <loader__circle cx="90" cy="263" r="6" fill="white" />
      <loader__circle cx="127" cy="263" r="6" fill="white" />
      <loader__circle cx="165" cy="263" r="6" fill="white" /> -->
    </svg>

    <div class="loader">
      <div class="loader__circle"></div>
      <div class="loader__circle"></div>
      <div class="loader__circle"></div>
      <div class="loader__circle"></div>
      <div class="loader__circle"></div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.loader__container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: $dark-blue;
}

.loader {
  display: flex;
  width: 171px;
  justify-content: space-between;
  padding-left: 5px;
}

.loader__circle {
  display: flex;
  min-width: 11px;
  min-height: 11px;
  border-radius: 50%;
  background: white;
  -webkit-animation: scale 1s infinite 0s;
  animation: scale 1s infinite;
  animation-timing-function: ease;
  -webkit-transform: scale(0);
  transform: scale(0);

  &:nth-child(2) {
    animation-delay: 100ms;
  }

  &:nth-child(3) {
    animation-delay: 200ms;
  }

  &:nth-child(4) {
    animation-delay: 300ms;
  }

  &:nth-child(5) {
    animation-delay: 300ms;
  }
}

@-webkit-keyframes scale {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
}

@keyframes scale {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
}
</style>
